import {Component, OnInit} from '@angular/core';
import {RmRateService} from '../../services/rm-rate.service';
import {RmRateInfoComponent} from '../rm-rate-info/rm-rate-info.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-rm-rate-list',
    templateUrl: './rm-rate-list.component.html',
    styleUrls: ['./rm-rate-list.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmRateListComponent implements OnInit {
    public rateMaster: any;
    public prepaidRates = [];
    public postpaidRates = [];
    // Provisional para que despues del 31 de agosto no se muestre la oferta
    public showOffer: boolean = false;

    constructor(
        private rateService: RmRateService,
        private modalService: NgbModal
    ) {
        // Provisional para que despues del 31 de agosto no se muestre la oferta
        let actualDate = new Date();
        let lastDayOffer = new Date(2020, 8, 1)
        if (actualDate <= lastDayOffer) {
            this.showOffer = true;
        }
    }

    ngOnInit(): void {
        this.rateService.getRatesFromService()
            .subscribe((data: any) => {
                this.rateMaster = data.msg;
                Array.prototype.push.apply(this.prepaidRates, this.rateMaster.mobile.pre.other);
                Array.prototype.push.apply(this.prepaidRates, this.rateMaster.mobile.pre.unlimited);
                Array.prototype.push.apply(this.postpaidRates, this.rateMaster.mobile.post.other);
                Array.prototype.push.apply(this.postpaidRates, this.rateMaster.mobile.post.unlimited);
                Array.prototype.push.apply(this.postpaidRates, this.rateMaster.additional.post);
            });
    }

    priceWithIVA(amount): number {
        return amount * 1.21;
    }

    modalMoreInfo(rate: any, subrate: any = null) {
        const modalRef = this.modalService.open(RmRateInfoComponent, {size: 'lg', centered: true});
        modalRef.componentInstance.rate = rate;
        modalRef.componentInstance.subrate = subrate;
    }

    openModalOffer(content) {
        this.modalService.open(content, {size: 'lg', centered: true});
    }
}
